
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import FingerprintJS, { GetResult } from "@fingerprintjs/fingerprintjs";
import { DeviceListEntry, WorkerReceiveMessage, WorkerSendMessage } from './data';
import { getBytes, getStorage, ref as storageRef, uploadBytes } from "firebase/storage";
import { getDatabase, ref as dbRef, set, get } from "firebase/database";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {

	apiKey: "AIzaSyCwfTwur5Mg9LZ-gyKsOwp4eeZ4UBS89oM",

	authDomain: "anapersimyenergy.firebaseapp.com",

	databaseURL: "https://cursordata.asia-southeast1.firebasedatabase.app/",

	projectId: "anapersimyenergy",

	storageBucket: "anapersimyenergy.firebasestorage.app",

	messagingSenderId: "119036386558",

	appId: "1:119036386558:web:5641efb3d3272e4e1d19af",

	measurementId: "G-JQPC32Y18J"

};
function generateInsecureUUID(): string {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		const r = Math.random() * 16 | 0;
		// For the 'y' position, the value must be 8, 9, A, or B (binary 10xx)
		// to conform to the UUID standard.
		const v = c === 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}
// Initialize Firebase
const app = initializeApp(firebaseConfig, "cursorAnalytics");
let ready: boolean = false;
let readyPromiseResolver: () => void = () => { }
const readyPromise: Promise<void> = new Promise((resolve) => {
	readyPromiseResolver = resolve;
})
let numberOfParts = 1;
const deviceID = localStorage.getItem("deviceID") ?? generateInsecureUUID();
localStorage.setItem("deviceID", deviceID);
const fingerprint = FingerprintJS.load();
const worker = new Worker(new URL('./worker.ts', import.meta.url), {
	type: 'module' // This enables module support
});
const lastClientPosition = { x: 0, y: 0 };
let appid: string = "";

const storage = getStorage(app);
const database = getDatabase(app);

export function getReady() {
	return ready;
}

export function waitReadyAsync(): typeof readyPromise {
	return readyPromise;
}

function sanitizeForFirebase<T>(data: T): unknown {
	if (data == null) {
		return null;
	}
	if (typeof data !== 'object') {
		return data;
	}
	if (Array.isArray(data)) {
		return data.map(item => sanitizeForFirebase(item));
	}
	const sanitizedObject: Record<string, unknown> = {};
	for (const key in data) {
		if (Object.prototype.hasOwnProperty.call(data, key)) {
			sanitizedObject[key] = sanitizeForFirebase((data as Record<string, unknown>)[key]);
		}
	}
	return sanitizedObject;
}

async function uploadFingerprint(x: GetResult) {
	try {
		const data: DeviceListEntry = (await get(dbRef(database, `/devices/${appid}/${deviceID}`))).val();
		await set(dbRef(database, `/devices/${appid}/${deviceID}`), {
			fingerprint: {
				...data.fingerprint,
				[x.visitorId]: sanitizeForFirebase(x)
			},
			numberOfParts: data.numberOfParts
		} as DeviceListEntry)
	} catch {
		await set(dbRef(database, `/devices/${appid}/${deviceID}`), {
			fingerprint: {
				[x.visitorId]: sanitizeForFirebase(x)
			},
			numberOfParts: 1
		} as DeviceListEntry)
	}
}

async function createOrGetPreviousParts() {
	try {
		const data: DeviceListEntry = (await get(dbRef(database, `/devices/${appid}/${deviceID}`))).val();
		numberOfParts = data.numberOfParts;
	} catch {
		numberOfParts = 1;
	}
	try {
		const pingRef = storageRef(storage, `pings/${appid}/` + deviceID + "_" + numberOfParts + ".datapack");
		const downloaded = await getBytes(pingRef);
		worker.postMessage({
			type: "setpreviouspart",
			compressedData: new Uint8Array(downloaded),
			numberOfParts: numberOfParts
		} as WorkerSendMessage)
	} catch {
		console.log("entirely new device")
	}
}

export function registerAnalyticswithAppID(appid2: string) {
	appid = appid2
	fingerprint.then(x => {
		ready = true;
		x.get().then(x => {
			uploadFingerprint(x).then(() => createOrGetPreviousParts())
			worker.postMessage({
				type: "fingerprintjs",
				data: x,
				deviceID
			} as WorkerSendMessage)
		})
		readyPromiseResolver();
	})

	worker.onmessage = (x: MessageEvent<WorkerReceiveMessage>) => {
		console.log("received")
		switch (x.data.type) {
			case "sendping":
				{
					const pingRef = storageRef(storage, `pings/${appid}/` + deviceID + "_" + x.data.numberOfParts + ".datapack");
					uploadBytes(pingRef, x.data.compressedData).then(() => {
						worker.postMessage({
							type: "uploaddone",
							uploadID: x.data.uploadID
						} as WorkerSendMessage)
					});
					break;
				}
		}
	}

	/* setInterval(() => {
		console.log("Forced send")
		worker.postMessage({
			type: "forcesend"
		} as WorkerSendMessage)
	}, 60000) */

	window.addEventListener('scroll', (e) => {
		// The mouse hasn't moved, but the scroll position has changed.
		// We call the same function to recalculate the position
		// using the stored clientX/Y and the new scrollY.
		mouseMove("mousemove", e.timeStamp);
	});

	registerMouseEvent("mousedown")
	registerMouseEvent("mouseenter")
	registerMouseEvent("mouseleave")
	registerMouseEvent("mousemove")
	registerMouseEvent("mouseout")
	registerMouseEvent("mouseover")
	registerMouseEvent("mouseup")
}

function registerMouseEvent(event: "mousedown" | "mousedown" |
	"mouseenter" |
	"mouseleave" |
	"mousemove" |
	"mouseout" |
	"mouseover" |
	"mouseup") {
	document.addEventListener(event, (ev: MouseEvent) => {
		lastClientPosition.x = ev.clientX;
		lastClientPosition.y = ev.clientY;
		mouseMove(event, ev.timeStamp)
	})
}

function mouseMove(eventname: string, timestamp: number) {
	// Get the current horizontal and vertical scroll positions
	const scrollX = window.scrollX;
	const scrollY = window.scrollY;
	// Calculate the position relative to the document by adding
	// the viewport position to the scroll offset.
	const calculatedPageX = lastClientPosition.x + scrollX;
	const calculatedPageY = lastClientPosition.y + scrollY;
	worker.postMessage({
		type: "mouseevent",
		eventtype: eventname,
		pageX: calculatedPageX,
		pageY: calculatedPageY,
		timestamp,
		absoluteTimestamp: performance.now()
	} as WorkerSendMessage)
}

